import { pickupNumbersUrl } from "../resources";
import getRequest from '../common/getRequest.js';

async function getPickupNumberByRestaurant(restaurantId, token) {
    
    let url = `${pickupNumbersUrl}/get/${restaurantId}`;
    let data;
    await getRequest.getDataWithToken(url, token)
                .then(response => {
                    data = response });
    return data;
}

export default {
    getPickupNumberByRestaurant
}
 
